import { initContract } from "@ts-rest/core";
import {
  NewDealRequestQueryReq,
  NewDealRequestSummaryView,
} from "../schemas/index.js";

const c = initContract();

export const newDealRequestsContract = c.router({
  getNewDealRequestsSummary: {
    method: "GET",
    path: "/new-deal-requests/summary",
    responses: {
      [200]: NewDealRequestSummaryView.array(),
    },
    query: NewDealRequestQueryReq,
    summary: "Gets basic informations about a set of New Deal Requests.",
  },
});
